import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ObservatoryService, UserService, StorageService } from '@services/services.module';
import { Subscription } from 'rxjs';
import { CalendarService } from '@components/calendar/calendar.service';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {

  private subscriptions: Array<Subscription> = [];
  public userData: any;
  public dateYear: any;
  public dateMonth: any;
  public dateMonthStr;
  public fechaBloqHasta;
  public anio: string;
  public mes: string;
  public dia: string;
  public bandera = true;
  public projectList: any = [];
  public employeList: any = [];
  public listAllClients: any = [];

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private _user: UserService,
    private storage: StorageService,
    private observatory: ObservatoryService,
    public _calendarService: CalendarService,
    private router: Router,
    public calendar: NgbCalendar
  ) {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });
    this.getUserData();
  }

  getUserData(): void {
    this._user.setInit();
    this.subscriptions.push(
      this._user.getUserData().subscribe((data) => {
        if (data) {
          this.observatory.setData('userData', data);
          this.storage.set('userDataStorage', data);
          this.userData = data;
        }
      })
    );
  }

  routeTo(route) {
    this.router.navigate([route]);
  }

  scrollTo(section) {
    document.querySelector('#' + section)
    .scrollIntoView();
  }
  /**
   * @name ngOnDestroy
   * @description Lifecycle hook
   */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }
}
